import React, { createContext, useCallback, useContext, useRef, useState } from 'react';
import { ToastContainer } from '../ui/Toast';

const ToastContext = createContext(null);

const DISPLAY_MS = 2800;
const EXIT_MS    = 200;

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const nextId = useRef(0);

  const toast = useCallback((message, { variant = 'success' } = {}) => {
    const id = nextId.current++;
    setToasts((prev) => [...prev, { id, message, variant, exiting: false }]);

    setTimeout(() => {
      setToasts((prev) => prev.map((t) => (t.id === id ? { ...t, exiting: true } : t)));
    }, DISPLAY_MS);

    setTimeout(() => {
      setToasts((prev) => prev.filter((t) => t.id !== id));
    }, DISPLAY_MS + EXIT_MS);
  }, []);

  return (
    <ToastContext.Provider value={{ toast }}>
      {children}
      <ToastContainer toasts={toasts} />
    </ToastContext.Provider>
  );
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be used inside ToastProvider');
  return ctx;
}
